import { render, staticRenderFns } from "./TopHeader2.vue?vue&type=template&id=07ed0d4e&scoped=true&"
import script from "./TopHeader2.vue?vue&type=script&lang=js&"
export * from "./TopHeader2.vue?vue&type=script&lang=js&"
import style0 from "./TopHeader2.vue?vue&type=style&index=0&id=07ed0d4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ed0d4e",
  null
  
)

export default component.exports